var _templateObject, _templateObject2, _templateObject3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled, { css } from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { SuperbannerStyle } from 'app/components/ads/adStylePlaceholders';
import { selectHydrationFinished } from 'app/hooks/reduxCreateSelectorHooks';
const PartnerTeaser = /*#__PURE__*/React.lazy(() => import('app/components/partner/PartnerTeaser'));
const SkyscraperAdSlot = /*#__PURE__*/React.lazy(() => import('app/components/ads/SkyscraperAdSlot.js'));
const SuperbannerAdSlot = /*#__PURE__*/React.lazy(() => import('app/components/ads/SuperbannerAdSlot'));
const MobileBannerAdSlot = /*#__PURE__*/React.lazy(() => import('app/components/ads/MobileBannerAdSlot'));
const FlexContainer = styled.div.withConfig({
  componentId: "sc-v2incs-0"
})(["display:flex;"]);
const Content = styled.div.withConfig({
  componentId: "sc-v2incs-1"
})(["margin-bottom:env(safe-area-inset-bottom);margin-left:env(safe-area-inset-left);margin-right:env(safe-area-inset-right);padding-top:", ";padding-bottom:", ";background-color:", ";max-width:", "px;", ""], SIZES['8'], props => props.contentPaddingBottom ? props.contentPaddingBottom : 0, props => props.bgColor ? COLORS.lighterGrey : COLORS.white, props => props.theme.desktopContentWidth, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 0 3rem 1rem;\n\n    // increase padding if background is white\n    ", ";\n\n     // show border for content on grey background\n     ", "\n   "])), props => (props.bgColor || props.noContentPadding) && css(["padding:0;"]), props => !props.bgColor && css(["border:1px solid ", ";"], COLORS.lightGrey)));
const ContentAdWrapper = styled.div.withConfig({
  componentId: "sc-v2incs-2"
})(["padding-top:", ";", ";display:flex;flex-direction:column;"], props => "calc(".concat(props.top, " + env(safe-area-inset-top))"), props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: ", "px;\n    // remove padding if there is no superbanner\n     ", ";\n    "])), props => props.theme.desktopContentWidth, props => props.hasNoPadding && css(["padding-top:env(safe-area-inset-top);"])));
const ContentWithStickyBanner = styled(Content).withConfig({
  componentId: "sc-v2incs-3"
})(["padding-bottom:4rem;", ""], props => props.theme.desktopLayout(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-bottom: 1.5rem;\n  "]))));
const ContentAdDesktop = /*#__PURE__*/React.forwardRef((props, ref) => {
  const hasNoPadding = !props.noAds && !props.skyscraperOnly;
  const hydrationFinished = useSelector(selectHydrationFinished);
  const superbanner = props.skyscraperOnly || props.noAds ? null : hydrationFinished ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(SuperbannerStyle, {
      top: props.top
    })
  }, /*#__PURE__*/React.createElement(SuperbannerAdSlot, {
    top: props.top
  })) : /*#__PURE__*/React.createElement(SuperbannerStyle, {
    top: props.top
  });
  const skyscraper = props.superbannerOnly || props.noAds ? null : hydrationFinished ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(SkyscraperAdSlot, {
    skyscraperOnly: props.skyscraperOnly,
    noTabs: props.noTabs
  })) : /*#__PURE__*/React.createElement("div", null);
  const partnerTeaser = props.noPartnerTeaser ? null : hydrationFinished ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(PartnerTeaser, {
    bgColor: props.bgColor
  })) : /*#__PURE__*/React.createElement("div", null);
  let mobileBanner = null;
  if (props.withMobileBanner) {
    if (hydrationFinished) {
      mobileBanner = /*#__PURE__*/React.createElement(Suspense, {
        fallback: /*#__PURE__*/React.createElement("div", null)
      }, /*#__PURE__*/React.createElement(MobileBannerAdSlot, null));
    } else {
      mobileBanner = /*#__PURE__*/React.createElement("div", null);
    }
  }
  return /*#__PURE__*/React.createElement(ContentAdWrapper, {
    id: "fupa-content",
    top: props.top,
    hasNoPadding: hasNoPadding
  }, superbanner, skyscraper, /*#__PURE__*/React.createElement(Content, _extends({}, props, {
    contentPaddingBottom: props.contentPaddingBottom,
    noContentPadding: props.noContentPadding,
    ref: ref
  }), mobileBanner, partnerTeaser, props.children), props.fabBtn);
});
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-v2incs-4"
})(["", " ", " ", " ", ""], props => props.lineHeight && "\n   line-height: ".concat(SIZES[props.lineHeight], ";\n  "), props => props.useOverflow && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ", props => props.textAlign && "\n    text-align: ".concat(props.textAlign, "\n  "), props => props.isDeactivated && "\n    color: ".concat(COLORS.darkGrey, ";\n  "));
export { FlexContainer, Content, ContentAdDesktop, ContentAdWrapper, ContentWithStickyBanner, StyledTypography };